module.exports = __webpack_public_path__ + "img/join_header.69093675.png";